// ----------------------------------------------------------------------------- //
//  Split paragraph into separate lines
// ----------------------------------------------------------------------------- //
document.addEventListener( 'DOMContentLoaded', function() {

	const text = document.querySelectorAll('.js-animate-text');

	if ( text.length ) {
		text.forEach( (e) => {

			const splitTextIntoLines = ( container, opentag, closingtag ) => {

				let spans = container.children;
				let top = 0;
				let tmp = '';

				container.innerHTML = container.textContent.replace(/\S+/g, '<n>$&</n>');

				for ( let i = 0; i < spans.length; i++ ) {

					let rect = spans[i].getBoundingClientRect().top;
					if (top < rect) tmp += closingtag + opentag;
					top = rect;
					tmp += spans[i].textContent + ' ';
				}

				container.innerHTML = tmp += closingtag;
			}

			splitTextIntoLines( e, '<span><span class="line">', '</span></span>' );
		});
	}

});
